import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'cnpj',
})
export class CnpjPipe implements PipeTransform {
    transform(value: string, ...args: any[]): any {
        if (!value) return value;

        // Remove apenas separadores de formatação — preserva letras (CNPJ alfanumérico)
        const cleaned = value.toString().replace(/[.\-\/\s]/g, "");

        // Formato: AA.AAA.AAA/AAAA-00 (12 caracteres alfanuméricos + 2 dígitos verificadores)
        return cleaned.replace(/^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    }

}